import Cart from '@/components/Pages/Cart'
import Checkout from '@/components/Pages/Checkout.vue'
import OrderTracking from '@/components/Pages/TrackOrder'

// profile start
import Catalog from '@/components/Pages/Catalog'
import ProductLandingPage from "@/components/Blocks/ProductLandingPage"
// profile end

var routes = [
  {
    path: '/:brand_id/:store_id/:order_id/track-order',
    name: 'goorder_track-order',
    component: OrderTracking,
    meta: {},
  },
  {
    path: '/:brand_id/store/:store_id/:delivery_area?',
    name: 'goorder_store_page',
    component: Catalog,
    meta: {
      data: {},
    },
  },
  {
    path: '/:brand_id/:store_id/category/:category_name/:delivery_area?',
    name: 'goorder_store_page_category',
    component: Catalog,
  },
  {
    path: '/:brand_id/:store_id/product/:product_id/:delivery_area?',
    name: 'product_landing_page',
    component: ProductLandingPage,
    meta: {
      data: {},
      title: 'Product Page',
    },
  },
  {
    path: '/:brand_id/:store_id/category/:category_name/product/:product_id/:delivery_area?',
    name: 'category_product_landing_page',
    component: Catalog,
  },
  {
    path: '/:brand_id/:store_id/cart',
    name: 'goorder_cart',
    component: Cart,
    meta: {
      data: {},
    },
  },
  {
    path: '/:brand_id/:store_id/checkout',
    name: 'goorder_checkout',
    component: Checkout,
    meta: {
      data: {},
    },
  },
]
export default routes
